import classnames from 'classnames';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';

import { CONTEXT, SHOP_MAIN_PAGE_URL, MICROCONTEXT } from '../config';
import styles from './Menu.module.less';
import { setActiveMenu, setStoreTheme } from '../actions/layout';
import { logPostInfo, logging } from '../actions/log';
import { cleanSearchRecommend } from '../actions/search';
import { GUI_MODE_INFO } from '../constants/storageKeys';
import { MENUS, MENUS_SMB } from '../constants/layout';
import { useAliveController } from 'react-activation';
import { localSetItem, localGetItem } from '../utils/utils';

const selectActiveMenu = createSelector(
  state => state.layout,
  layout => layout.activeMenu,
);
const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSoftsAll,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectIsShowMenuSpot = createSelector(
  state => state.layout,
  native => native.isShowMenuSpot,
);
const selectGameTabs = createSelector(
  state => state.game,
  game => game.menu,
);

const logSourcePage = {
  [`${CONTEXT}/recommend`]: 'Recommend',
  [`${CONTEXT}/category`]: 'Classify',
  [`${CONTEXT}/topn`]: 'Rank',
  [`${CONTEXT}/game`]: 'Game',
  [`${CONTEXT}/gameSelect`]: 'Game',
  [`${CONTEXT}/education`]: 'Education',
  [`${CONTEXT}/work`]: 'Work',
  [`${CONTEXT}/shop`]: 'Shop',
  [`${CONTEXT}/update`]: 'Update',
  [`${CONTEXT}/uninstall`]: 'Uninstall',
  [`${CONTEXT}/arecommend`]: 'ARecommend',
  [`${CONTEXT}/acategory`]: 'ACategory',
  [`${CONTEXT}/android/detail`]: 'AndroidDetail',

  [`${CONTEXT}/detail`]: 'AppDetail',
  [`${CONTEXT}/search`]: 'Search',
  [`${CONTEXT}/guesslikesmore`]: 'Reco_Guess_More',
  [`${CONTEXT}/topnmore`]: 'Rank_More_Page',
  [`${CONTEXT}/dt`]: 'dt',
  [`${CONTEXT}/messagecore`]: 'messagecore',
  [`${CONTEXT}/wallpaper`]: 'wallpaper',
  [`${CONTEXT}/wpdetail`]: 'wpdetail',
  [`${CONTEXT}${MICROCONTEXT}`]: 'forum',
  // [`${CONTEXT}/discover`]: 'Discover',
  [`${CONTEXT}/discount`]: 'Discount',
};

export default memo(() => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const activeMenu = useSelector(selectActiveMenu); // 当前激活的菜单，用于设置选中的菜单
  const upgradeSoftsData = useSelector(selectUpgradeSofts);
  const logInfoData = useSelector(selectLogInfo);
  const isShowMenuSpot = useSelector(selectIsShowMenuSpot); // 是否展示菜单上小红点
  const gameTabs = useSelector(selectGameTabs);

  const [updateSoftCount, setUpdateSoftCount] = useState(0);
  const [meunPoint, setMeunPoint] = useState({});

  const [logFlag, setLogFlag] = useState(false); // 只报一次更新列表的桩
  const [showMenus, setShowMenus] = useState([]); // 需要展示的菜单

  const { drop, dropScope, refresh } = useAliveController();

  // 根据gui_mode系统模式   确认默认路由
  const getDefaultMENUS = useCallback(() => {
    // 从数据库中获取gui_mode系统模式
    let guiModeInfo = JSON.parse(localGetItem(GUI_MODE_INFO) || '{}');
    if (!guiModeInfo || !guiModeInfo.guiMode) {
      // 从数据库中获取gui_mode系统模式失败，就直接接口获取
      if (window.external && window.external.get_bizparam && window.external.get_gui_mode) {
        let bizParam =
          window.external.get_bizparam() || JSON.parse(window.external.bizparam || '{}');
        let guiMode = window.external.get_gui_mode() || '';
        guiModeInfo = { ...bizParam, guiMode };
        localSetItem(GUI_MODE_INFO, JSON.stringify(guiModeInfo));
      }
    }
    return guiModeInfo.businessCode === 'SMB' ? MENUS_SMB : MENUS;
  }, []);

  const MENU_ARR = getDefaultMENUS();

  const getSP = useCallback(() => {
    const { pathname } = location;
    let source_p = 'null';
    if (logSourcePage[pathname]) {
      source_p = logSourcePage[pathname];
    } else if (pathname.indexOf('/detail') > -1) {
      source_p = logSourcePage[`${CONTEXT}/detail`];
    } else if (pathname.indexOf('/search') > -1) {
      source_p = logSourcePage[`${CONTEXT}/search`];
    } else if (pathname.indexOf('/topnmore') > -1) {
      source_p = logSourcePage[`${CONTEXT}/topnmore`];
    }
    return source_p;
  }, []);

  const handleActive = useCallback(
    pathname => {
      let logAction = `Menu_Err`;
      if (logSourcePage[pathname]) {
        logAction = `Menu_${logSourcePage[pathname]}`;
      }
      if (pathname.indexOf('game') > -1 || pathname.indexOf('Game') > -1) {
        logAction = `Menu_Game`;
      }
      if (pathname.indexOf('education') > -1 || pathname.indexOf('Education') > -1) {
        logAction = `Menu_Education`;
      }
      // const logAction = logSourcePage[pathname] ? `Menu_${logSourcePage[pathname]}` : `Menu_Err`;
      // menu切换打桩
      dispatch(
        logging({
          category: 'C',
          action: logAction,
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: logInfoData.source || getSP(),
          source_pp: logInfoData.source_p,
        }),
      );

      dispatch(cleanSearchRecommend());
      if (pathname === `${CONTEXT}${MICROCONTEXT}`) {
        history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumlist?from=menu`);
        return;
      }
      if (pathname === 'shop') {
        window.open(SHOP_MAIN_PAGE_URL);
        return;
      }

      if (pathname.indexOf('wallpaper') > -1) {
        if (!localStorage.getItem('NEW_WALLPAPER')) {
          localStorage.setItem('NEW_WALLPAPER', 1);
        } else {
          localStorage.setItem('NEW_WALLPAPER', ~~localStorage.getItem('NEW_WALLPAPER') + 1);
        }
      }
    },
    [logInfoData],
  );

  // 点击主菜单 删除节点缓存
  const handleDeleteALive = useCallback((current, path) => {
    const menus = MENU_ARR;
    if (current === 'gameSelect') {
      dropScope(`game`);
      refresh(`game${current}`);
      gameTabs.forEach(item => {
        dropScope(`game${item.code}`);
      });
    }
    if (menus.indexOf(current) > -1 && window.location.pathname.indexOf(path) === -1) {
      // 首先删除点击菜单的缓存
      dropScope(current);
      if (current === 'edurecommend') {
        dropScope('edumine');
        dropScope('educategory');
      }
      if (current === 'wallpaper') {
        dropScope('wallpaper');
        dropScope('wpcateg');
        dropScope('wpmine');
      }
    }

    // 点击菜单 为了删除缓存drop(current)生效，所以setTimeout之后在push页面
    if (window.location.pathname !== path) {
      setTimeout(() => {
        history.push(path);
      }, 50);
    }
  }, []);

  // new标只能点击一次
  const handleMenuPoint = useCallback(
    flag => {
      let meunPointNew = { ...meunPoint };
      if (flag === 'discover') {
        meunPointNew.discover = 1;
      }
      if (flag === 'discount') {
        meunPointNew.discount = 1;
      }
      meunPointNew[flag] = 1;
      localSetItem('MENU_POINT', JSON.stringify(meunPointNew));
      setMeunPoint({ ...meunPointNew });
    },
    [meunPoint],
  );

  const getMenuByRecord = useCallback(
    (menuName, index) => {
      if (menuName === 'recommend') {
        let active = activeMenu.indexOf(`${CONTEXT}/recommend`) > -1;
        return (
          <div
            key={index}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleDeleteALive('recommend', `${CONTEXT}/recommend`);
              handleActive(`${CONTEXT}/recommend`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_reco_h' : 'icon-menu_reco'}`} />
            <span className="tit">推荐</span>
            <span className="change_menu" />
          </div>
        );
      } else if (menuName === 'game') {
        let active = activeMenu.indexOf(`${CONTEXT}/game`) > -1;
        return (
          <div
            key={index}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleDeleteALive('gameSelect', `${CONTEXT}/game/gameSelect`);
              handleActive(`${CONTEXT}/game/gameSelect`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_game_h' : 'icon-menu_game'}`} />
            <span className="tit">游戏</span>
            {+new Date('2023-7-17 00:00:01') - +new Date() < 0 &&
              +new Date('2023-8-30 23:59:59') - +new Date() > 0 && <span className="pointer_hot" />}
            <span className="change_menu" />
          </div>
        );
      } else if (menuName === 'education') {
        let active = activeMenu.indexOf(`${CONTEXT}/education`) > -1;
        return (
          <div
            key={index}
            to={`${CONTEXT}/education/pceduSelect`}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleDeleteALive('pceduSelect', `${CONTEXT}/education/pceduSelect`);
              handleActive(`${CONTEXT}/education/pceduSelect`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_edu_h' : 'icon-menu_edu'}`} />
            <span className="tit">教育</span>
            <span className="change_menu" />
          </div>
        );
      } else if (menuName === 'work') {
        let active = activeMenu.indexOf(`${CONTEXT}/work`) > -1;
        return (
          <div
            key={index}
            to={`${CONTEXT}/work`}
            className={classnames('item', { active: active })}
            onClick={() => {
              handleDeleteALive('work', `${CONTEXT}/work`);
              handleActive(`${CONTEXT}/work`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_work_h' : 'icon-menu_work'}`} />
            <span className="tit">办公</span>
            {+new Date('2022-11-01 12:00:00') < +new Date() &&
              +new Date('2022-11-16 23:59:59') > +new Date() && <span className="pointer_hot11" />}
            <span className="change_menu" />
          </div>
        );
      }
      // else if (menuName === 'discover') {
      //   let active = activeMenu.indexOf(`${CONTEXT}/discover`) > -1;
      //   return (
      //     <div
      //       key={index}
      //       to={`${CONTEXT}/discover`}
      //       className={classnames('item', { active: active })}
      //       onClick={() => {
      //         handleDeleteALive('discover', `${CONTEXT}/discover`);
      //         handleActive(`${CONTEXT}/discover`);
      //         handleMenuPoint('discover');
      //       }}
      //     >
      //       <i className={`${active ? 'menu_tansuo_h' : 'menu_tansuo'}`} />
      //       <span className="tit">探索</span>
      //       {(+new Date('2022-7-31 23:59:59') - +new Date() > 0 ||
      //         (+new Date('2022-8-31 23:59:59') - +new Date() > 0 && meunPoint.discover !== 1)) && (
      //         <span className="pointer_new" />
      //       )}
      //       <span className="change_menu" />
      //     </div>
      //   );
      // }
      else if (menuName === 'category') {
        let active = activeMenu.indexOf(`${CONTEXT}/category`) > -1;
        return (
          <div
            key={index}
            to={`${CONTEXT}/category`}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleDeleteALive('category', `${CONTEXT}/category`);
              handleActive(`${CONTEXT}/category`);
            }}
          >
            <i
              className={`icon iconfont ${active ? 'icon-menu_category_h' : 'icon-menu_category'}`}
            />
            <span className="tit">分类</span>
          </div>
        );
      } else if (menuName === 'wallpaper') {
        let active = activeMenu.indexOf(`${CONTEXT}/wallpaper`) > -1;
        return (
          <Link
            key={index}
            to={`${CONTEXT}/wallpaper`}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleActive(`${CONTEXT}/wallpaper`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_wall_h' : 'icon-menu_wall'}`} />
            <span className="tit">壁纸</span>
            {+new Date('2020-10-31 23:59:59') - +new Date() > 0 && <span className="pointer_new" />}
          </Link>
        );
      } else if (menuName === 'forum') {
        let active = activeMenu.indexOf(`${CONTEXT}${MICROCONTEXT}`) > -1;
        return (
          <div
            key={index}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleActive(`${CONTEXT}${MICROCONTEXT}`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_forum_h' : 'icon-menu_forum'}`} />
            <div className="spot_box">
              <span className="tit">圈子</span>
              {+new Date('2022-2-1 23:59:59') - +new Date() > 0 && (
                <span className="pointer_hot_forum" />
              )}
            </div>
          </div>
        );
      } else if (menuName === 'update') {
        let active = activeMenu.indexOf(`${CONTEXT}/update`) > -1;
        return (
          <div
            key={index}
            to={`${CONTEXT}/update`}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleDeleteALive('update', `${CONTEXT}/update`);
              handleActive(`${CONTEXT}/update`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_update_h' : 'icon-menu_update'}`} />
            <span className="tit">升级</span>
            {updateSoftCount > 0 && <span className="pointer">{updateSoftCount}</span>}
          </div>
        );
      } else if (menuName === 'uninstall') {
        let active = activeMenu.indexOf(`${CONTEXT}/uninstall`) > -1;
        return (
          <div
            key={index}
            to={`${CONTEXT}/uninstall`}
            className={classnames('item', {
              active: active,
            })}
            onClick={() => {
              handleDeleteALive('uninstall', `${CONTEXT}/uninstall`);
              handleActive(`${CONTEXT}/uninstall`);
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-menu_mysoft_h' : 'icon-menu_mysoft'}`} />
            <div className="spot_box">
              <span className="tit">我的</span>
              {isShowMenuSpot && <span className="spot" />}
            </div>
          </div>
        );
      } else if (menuName === 'discount') {
        let active = activeMenu.indexOf(`${CONTEXT}/discount`) > -1;
        return (
          <div
            key={index}
            to={`${CONTEXT}/discount`}
            className={classnames('item', { active: active })}
            onClick={() => {
              handleDeleteALive('discount', `${CONTEXT}/discount`);
              handleActive(`${CONTEXT}/discount`);
              handleMenuPoint('discount');
            }}
          >
            <i className={`icon iconfont ${active ? 'icon-a-xuanzhong3' : 'icon-changgui'}`} />
            {/* <i className={`icon iconfont ${active ? 'icon-sale_normal' : 'icon-sale_press'}`} /> */}
            <span className="tit">折扣</span>
            {+new Date('2023-12-22 23:59:59') - +new Date() > 0 &&
              +new Date() - +new Date('2023-12-11 0:0:0') > 0 && <span className="discount_tag" />}
            <span className="change_menu" />
          </div>
        );
      }
    },
    [activeMenu, updateSoftCount, isShowMenuSpot],
  );

  // 产品需要  当更新数据获取得到了，就打桩上报可更新数目
  useEffect(() => {
    if (upgradeSoftsData !== null && logFlag === false) {
      setLogFlag(true);
      const pc_softids = [];
      const a_pkg = [];
      const tempData =
        upgradeSoftsData.filter(
          item => !item.permanentIgnore && (!item.bIgnore || item.ignoredVersion !== item.version),
        ) || [];

      tempData.forEach(soft => {
        if (soft.androidType === '1') {
          a_pkg.push(soft.packageName);
        } else {
          pc_softids.push(soft.softID);
        }
      });
      dispatch(
        logging({
          category: 'I',
          action: 'UpdateApp',
          label: '',
          param2: {
            update_total: tempData.length,
            pc_update_total: pc_softids.length,
            pc_update_softid: pc_softids.join(', '),
            a_update_total: a_pkg.length,
            a_update_pkg: a_pkg.join(', '),
          },
        }),
      );
    }
  }, [dispatch, upgradeSoftsData]);

  /**
   * 控制激活的菜单
   */
  useEffect(() => {
    const { pathname } = location;
    if (pathname && pathname.split(`${CONTEXT}/`)[1]) {
      const currPage = pathname && pathname.split(`${CONTEXT}/`)[1].split('/')[0];

      let active_menu = '';
      if (currPage === 'recommend' && MENU_ARR.indexOf('recommend') > -1) {
        active_menu = `${CONTEXT}/recommend`;
      } else if (currPage === 'game' && MENU_ARR.indexOf('game') > -1) {
        active_menu = `${CONTEXT}/game`;
      } else if (
        (currPage === 'education' || currPage === 'edudetail') &&
        MENU_ARR.indexOf('education') > -1
      ) {
        active_menu = `${CONTEXT}/education`;
      } else if (currPage === 'work' && MENU_ARR.indexOf('work') > -1) {
        active_menu = `${CONTEXT}/work`;
      }
      // else if (currPage === 'discover' && MENU_ARR.indexOf('discover') > -1) {
      //   active_menu = `${CONTEXT}/discover`;
      // }
      else if (currPage === 'category' && MENU_ARR.indexOf('category') > -1) {
        active_menu = `${CONTEXT}/category`;
      } else if (
        (currPage === 'wallpaper' || currPage === 'wpdetail') &&
        MENU_ARR.indexOf('wallpaper') > -1
      ) {
        active_menu = `${CONTEXT}/wallpaper`;
      } else if (currPage === 'update' && MENU_ARR.indexOf('update') > -1) {
        active_menu = `${CONTEXT}/update`;
      } else if (currPage === 'uninstall' && MENU_ARR.indexOf('uninstall') > -1) {
        active_menu = `${CONTEXT}/uninstall`;
      } else if (`/${currPage}` === MICROCONTEXT && MENU_ARR.indexOf('forum') > -1) {
        active_menu = `${CONTEXT}${MICROCONTEXT}`;
      } else if (currPage === 'discount' && MENU_ARR.indexOf('discount') > -1) {
        active_menu = `${CONTEXT}/discount`;
      }
      if (window.history.length <= 2) {
        dispatch(setActiveMenu(active_menu || `${CONTEXT}/${MENU_ARR[0]}`));
      } else {
        active_menu && dispatch(setActiveMenu(active_menu));
      }
    }
  }, [dispatch, location.pathname, MENU_ARR]);

  // 升级软件数量
  useEffect(() => {
    const len =
      upgradeSoftsData &&
      upgradeSoftsData.filter(
        item => !item.permanentIgnore && (!item.bIgnore || item.ignoredVersion !== item.version),
      ).length;
    setUpdateSoftCount(len);
  }, [upgradeSoftsData]);

  // new标只能点击一次
  useEffect(() => {
    try {
      let meunPointLocal = localGetItem('MENU_POINT') || '{}';
      setMeunPoint(JSON.parse(meunPointLocal));
    } catch (error) {}
  }, []);

  useEffect(() => {
    var menus = MENU_ARR.map((item, index) => {
      return getMenuByRecord(item, index);
    });
    setShowMenus(menus);
  }, [activeMenu, updateSoftCount, isShowMenuSpot]);

  return (
    <div className={styles.menu}>
      {showMenus.map((item, index) => {
        return item;
      })}
    </div>
  );
});
